/* eslint-disable prettier/prettier */
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  FaStickyNote,
  FaExclamationTriangle,
  FaTasks,
  FaBook,
} from "react-icons/fa";
import NotesObservationsPage from "./NotesObservationsPage";
import IncidentReportingPage from "./IncidentReportingPage";
import TasksPage from "./TasksPage";
import InstructionsPage from "./InstructionsPage";

const NotesIncidentsPage = () => {
  const location = useLocation();

  let activeSubPage;
  if (location.pathname.startsWith("/notes-incidents/incidents")) {
    activeSubPage = "incidents";
  } else if (location.pathname.startsWith("/notes-incidents/tasks")) {
    activeSubPage = "tasks";
  } else if (location.pathname.startsWith("/notes-incidents/instructions")) {
    activeSubPage = "instructions";
  } else {
    // default to notes
    activeSubPage = "notes";
  }

  // prettier-ignore
  const navLinkClasses =
    "flex items-center justify-center gap-1 px-4 py-3 text-sm font-medium rounded-t-lg transition-colors duration-200";
  // prettier-ignore - use theme colors for active tabs
  const activeNotesLinkClasses =
    "text-yellow-600 bg-white border-b-2 border-yellow-600";
  // prettier-ignore
  const activeIncidentsLinkClasses =
    "text-orange-600 bg-white border-b-2 border-orange-600";
  const activeTasksLinkClasses =
    "text-green-600 bg-white border-b-2 border-green-600";
  const activeInstructionsLinkClasses =
    "text-blue-600 bg-white border-b-2 border-blue-600";
  // prettier-ignore
  const inactiveLinkClasses =
    "text-gray-500 hover:text-gray-700 hover:bg-gray-100";

  const notesClasses = `${navLinkClasses} ${
    activeSubPage === "notes" ? activeNotesLinkClasses : inactiveLinkClasses
  }`;
  // prettier-ignore
  const incidentsClasses = `${navLinkClasses} ${
    activeSubPage === "incidents" ? activeIncidentsLinkClasses : inactiveLinkClasses
  }`;
  const tasksClasses = `${navLinkClasses} ${
    activeSubPage === "tasks" ? activeTasksLinkClasses : inactiveLinkClasses
  }`;
  // prettier-ignore
  const instructionsClasses = `${navLinkClasses} ${
    activeSubPage === "instructions" ? activeInstructionsLinkClasses : inactiveLinkClasses
  }`;

  return (
    <div className="container mx-auto p-4 md:p-6 space-y-6">
      <div className="flex flex-wrap gap-2 border-b border-gray-200">
        <NavLink to="/notes-incidents/notes" className={notesClasses}>
          <FaStickyNote />
          <span>Notes</span>
        </NavLink>
        <NavLink to="/notes-incidents/incidents" className={incidentsClasses}>
          <FaExclamationTriangle />
          <span>Health Events</span>
        </NavLink>
        <NavLink to="/notes-incidents/tasks" className={tasksClasses}>
          <FaTasks />
          <span>Tasks</span>
        </NavLink>
        <NavLink to="/notes-incidents/instructions" className={instructionsClasses}>
          <FaBook />
          <span>Instructions</span>
        </NavLink>
      </div>

      {activeSubPage === "notes" && <NotesObservationsPage />}
      {activeSubPage === "incidents" && <IncidentReportingPage />}
      {activeSubPage === "tasks" && <TasksPage />}
      {activeSubPage === "instructions" && <InstructionsPage />}
    </div>
  );
};

export default NotesIncidentsPage;
